var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-height width-100 padding-90 flex-row justify-content-center align-items-center"},[_c('img',{attrs:{"src":require('../assets/image/paySuccess2.png'),"width":"50%","fit":"contain"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }